import React, {Component} from 'react';
import {Row, Col} from 'react-bootstrap';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import StockItList from './stock-it-list';
import ArrowButton from '../../../common/button-arrow';
import { getStockItObjectives } from '../../../../actions/stock-it';
import PageTitle from '../../../common/page-title';

import './styles.css';
import StockItSearch from './stock-it-search';

class StockIt extends Component {
  state = {
    name: ''
  };

  handleNameChange = (e) => {
    this.setState({ name: e.target.value });
  };

  handleClear = () => {
    this.setState({
      name: ''
    }, this.handleSearch);
  };

  handleSearch = () => {
    const { dispatch } = this.props;
    const { name } = this.state;

    dispatch(getStockItObjectives(name));
  };
  componentWillMount() {
    this.props.dispatch(getStockItObjectives());
  }

  render() {
    const { name } = this.state;
    return (
      <div className='container-fluid incentives'>
        <Row>
          <PageTitle>Stock It</PageTitle>
          <StockItSearch
            eventValue={name}
            onNameChange={this.handleNameChange}
            onSearch={this.handleSearch}
            onClear={this.handleClear}
          />
          <Col md={12}>
            <Row>
              <Link to='/admin/objectives/stock-it/new'>
                <ArrowButton
                  color='red'
                  arrow={false}
                  submit={false}
                  className='add-stock-it'
                >
                  ADD STOCK IT SUB OBJECTIVE
                </ArrowButton>
              </Link>
            </Row>
          </Col>

          <Row>
            <Col md={12}>
              <StockItList
                stockIts={this.props.stock_it_objectives}
                fetching={this.props.fetching}
                fetched={this.props.fetched}
                onPageChange={this.handlePageChange}
              />
            </Col>
          </Row>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  stock_it_objectives: state.stock_its.stock_it_objectives,
  fetching: state.stock_its.fetching,
  fetched: state.stock_its.fetched,
});

export default connect(mapStateToProps)(StockIt);



// WEBPACK FOOTER //
// ./src/components/admin/objectives/stock_it/index.jsx